export default __webpack_public_path__ + "static/media/me-(4).16a31b0c.png";